import React, { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import "./BottomNav.css";

import {
  FiAward,
  FiBarChart2,
  FiBell,
  FiCalendar,
  FiFileText,
  FiHome,
  FiImage,
  FiLayers,
  FiList,
  FiLock,
  FiMoreHorizontal,
  FiShield,
  FiShuffle,
  FiTable,
  FiUser,
  FiUsers,
  FiX,
} from "react-icons/fi";

const fullNavigationByRole = {
  admin: [
    { path: "https://bongbanhadong.com", icon: FiHome, label: "Trang chủ", external: true, activePattern: /^\/$/ },
    { path: "/schedules", icon: FiCalendar, label: "Lịch", activePattern: /^\/schedules/ },
    { path: "/draw", icon: FiShuffle, label: "Bốc thăm", activePattern: /^\/draw/ },
    { path: "/teams", icon: FiShield, label: "Đội", activePattern: /^\/teams/ },
    { path: "/players", icon: FiUsers, label: "VĐV", activePattern: /^\/players/ },
    { path: "/seasons", icon: FiAward, label: "Mùa giải", activePattern: /^\/seasons/ },
    { path: "/levels", icon: FiBarChart2, label: "Hạng", activePattern: /^\/levels/ },
    { path: "/tables", icon: FiTable, label: "Bảng đấu", activePattern: /^\/tables/ },
    { path: "/rosters", icon: FiList, label: "Roster", activePattern: /^\/rosters/ },
    { path: "/tournaments", icon: FiAward, label: "Giải cá nhân", activePattern: /^\/tournaments/ },
    {
      path: "/individual-matches",
      icon: FiLayers,
      label: "Trận cá nhân",
      activePattern: /^\/individual-matches/,
    },
    {
      path: "/notifications",
      icon: FiBell,
      label: "Thông báo",
      activePattern: /^\/notifications/,
    },
    { path: "/users", icon: FiUser, label: "Users", activePattern: /^\/users/ },
    {
      path: "/change-password",
      icon: FiLock,
      label: "Mật khẩu",
      activePattern: /^\/change-password/,
    },
    { path: "/news", icon: FiFileText, label: "Tin tức", activePattern: /^\/news/ },
    { path: "/ads", icon: FiImage, label: "Quảng cáo", activePattern: /^\/ads/ },
  ],
  manager: [
    { path: "https://bongbanhadong.com", icon: FiHome, label: "Trang chủ", external: true, activePattern: /^\/$/ },
    { path: "/schedules", icon: FiCalendar, label: "Lịch", activePattern: /^\/schedules/ },
    { path: "/draw", icon: FiShuffle, label: "Bốc thăm", activePattern: /^\/draw/ },
    { path: "/teams", icon: FiShield, label: "Đội", activePattern: /^\/teams/ },
    { path: "/players", icon: FiUsers, label: "VĐV", activePattern: /^\/players/ },
    { path: "/rosters", icon: FiList, label: "Roster", activePattern: /^\/rosters/ },
    {
      path: "/notifications",
      icon: FiBell,
      label: "Thông báo",
      activePattern: /^\/notifications/,
    },
    {
      path: "/change-password",
      icon: FiLock,
      label: "Mật khẩu",
      activePattern: /^\/change-password/,
    },
  ],
  bks: [
    { path: "https://bongbanhadong.com", icon: FiHome, label: "Trang chủ", external: true, activePattern: /^\/$/ },
    { path: "/players", icon: FiUsers, label: "VĐV", activePattern: /^\/players/ },
    {
      path: "/notifications",
      icon: FiBell,
      label: "Thông báo",
      activePattern: /^\/notifications/,
    },
    {
      path: "/change-password",
      icon: FiLock,
      label: "Mật khẩu",
      activePattern: /^\/change-password/,
    },
  ],
};

const primaryByRole = {
  admin: ["https://bongbanhadong.com", "/schedules", "/teams", "/notifications"],
  manager: ["https://bongbanhadong.com", "/schedules", "/teams", "/notifications"],
  bks: ["https://bongbanhadong.com", "/players", "/notifications", "/change-password"],
};

const BottomNav = ({ unreadCount = 0 }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [sheetOpen, setSheetOpen] = useState(false);

  const allItems = fullNavigationByRole[user?.role] || fullNavigationByRole.manager;
  const primaryPaths = primaryByRole[user?.role] || primaryByRole.manager;
  const primaryItems = allItems.filter((item) => primaryPaths.includes(item.path));

  const isActive = (pattern) => pattern.test(location.pathname);
  const isMoreActive = allItems
    .filter((item) => !primaryPaths.includes(item.path))
    .some((item) => isActive(item.activePattern));

  const goTo = (item) => {
    setSheetOpen(false);
    if (item.external) {
      window.location.href = item.path;
      return;
    }
    navigate(item.path);
  };

  const renderBadge = (item) =>
    item.path === "/notifications" && unreadCount > 0 ? (
      <span className="bottom-nav-badge">{unreadCount > 99 ? "99+" : unreadCount}</span>
    ) : null;

  return (
    <>
      {sheetOpen && (
        <div className="bottom-nav-sheet-backdrop" onClick={() => setSheetOpen(false)}>
          <div className="bottom-nav-sheet" onClick={(event) => event.stopPropagation()}>
            <div className="bottom-nav-sheet-head">
              <div>
                <strong>Menu admin</strong>
                <span>{user?.role || "user"}</span>
              </div>
              <button type="button" onClick={() => setSheetOpen(false)} aria-label="Đóng menu">
                <FiX />
              </button>
            </div>
            <div className="bottom-nav-sheet-grid">
              {allItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.path}
                    type="button"
                    className={isActive(item.activePattern) ? "active" : ""}
                    onClick={() => goTo(item)}
                  >
                    <Icon />
                    {renderBadge(item)}
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

      <nav className="bottom-nav" aria-label="Điều hướng nhanh mobile">
        <div className="bottom-nav-container">
          {primaryItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                type="button"
                className={`bottom-nav-item ${
                  isActive(item.activePattern) ? "active" : ""
                }`}
                onClick={() => goTo(item)}
              >
                <Icon className="bottom-nav-icon" />
                {renderBadge(item)}
                <span className="bottom-nav-label">{item.label}</span>
              </button>
            );
          })}
          <button
            type="button"
            className={`bottom-nav-item ${sheetOpen || isMoreActive ? "active" : ""}`}
            onClick={() => setSheetOpen(true)}
          >
            <FiMoreHorizontal className="bottom-nav-icon" />
            <span className="bottom-nav-label">Thêm</span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
